import { Input } from "antd";

const UnitWithInput = ({
  label,
  value,
  onChange,
  unit,
  onUnitChange,
  disabled,
  unitList,
  error,
}) => {
  return (
    <div className="input-box">
      <label>{label}</label>
      <div className="input-container">
        <Input
          disabled={disabled}
          value={value}
          placeholder={label}
          onChange={onChange}
          style={{ flex: 1, border: "none", padding: "2px 8px" }}
        />
        <select value={unit} onChange={onUnitChange} disabled={disabled} className="unit-dropdown">
          {unitList.map((unitValue) => (
            <option key={unitValue} value={unitValue}>
              {unitValue}
            </option>
          ))}
        </select>
      </div>
      {error && <span style={{ color: "red" }}>{error}</span>}
    </div>
  );
};

export default UnitWithInput;
